import expireSession from '@Application/Security/Authentications/expireSession';
import watchSessionLoss from '@Application/Security/Authentications/watchSessionLoss';
import * as React from 'react';
import { useDispatch, useSelector } from '@verclam/synapse';

type Props = {
	readonly children?: React.ReactNode;
};

/**
 * Turns a request still answered 401 after a token refresh into a local session expiry, so the
 * route guards redirect to `/login` with the current page as `from`. Renders its children untouched.
 */
const SessionLossWatcher: React.FC<Props> = ({ children }) => {
	const dispatch = useDispatch();
	const sessionStatus = useSelector((state) => state.authenticatedUserStore.sessionStatus);
	const sessionStatusRef = React.useRef(sessionStatus);

	sessionStatusRef.current = sessionStatus;

	React.useEffect(() => {
		return watchSessionLoss(() => {
			if (sessionStatusRef.current !== 'authenticated') {
				return;
			}

			// Flipped before the store update lands: a burst of parallel 401s expires the session once.
			sessionStatusRef.current = 'anonymous';
			dispatch(expireSession());
		});
	}, [dispatch]);

	return <React.Fragment>{children}</React.Fragment>;
};

export default SessionLossWatcher;
